import { render } from "./DemoNaggingPopup.vue?vue&type=template&id=6e7ca55d"
import script from "./DemoNaggingPopup.vue?vue&type=script&lang=ts"
export * from "./DemoNaggingPopup.vue?vue&type=script&lang=ts"
script.render = render

export default script